import React from "react";
import EmptyResultIcon from "../../assets/img/empty-result.svg";
import { BaseButton } from "../base";
import { useNavigate } from "react-router-dom";
const EmptyResult = ({ showButton }: { showButton?: boolean }) => {
    const router = useNavigate();
    return (
        <div className="py-8">
            <div className="flex flex-col sm:w-2/3 lg:w-1/2 mx-auto justify-center w-full items-center">
                <div className="mb-6">
                    <img src={EmptyResultIcon} alt="" className="w-[100px]" />
                </div>
                <div className="mb-4">
                    <p className="mx-4 text-[#525256] text-center text-[1rem] font-[500]">
                        You currently have no result
                    </p>
                </div>

                {showButton && (
                    <BaseButton
                        text="Book a Test"
                        type="button"
                        // processing={isUpdating}
                        variant="primary"
                        styles="!px-8"
                        click={() => router("/dashboard/order-test")}
                    />
                )}
            </div>
        </div>
    );
};

export default EmptyResult;
